import MitLandingPage from '../pages/MitLandingPage.vue';

//USER
import MitDashboardPage from '../pages/MitDashboardPage.vue';
import MitMyReservationsPage from '../pages/MitMyReservationsPage.vue';
import MitReservePage from '../pages/MitReservePage.vue';
import MitSettingsPage from '../pages/MitSettingsPage.vue';

//MANAGER
import MitManageReservationsPage from '../pages/manage/MitManageReservationsPage.vue';
import MitManageReservationsSetupPage from '../pages/manage/MitManageReservationsSetupPage.vue';
import MitManageAuditPage from '../pages/manage/MitManageAuditPage.vue';
import MitManagerDashboardPage from '../pages/manage/MitManagerDashboardPage.vue';



//ADMIN
import MitAdminPage from '../pages/admin/MitAdminPage.vue';
import MitAdminReservableSpacesPage from '../pages/admin/MitAdminReservableSpacesPage.vue';
import MitAdminImportReservationsPage from '../pages/admin/MitAdminImportReservationsPage.vue';


export const defaultRoute = 'reserve';

export function getAppRoutes(MitUserModel, routerGuardAccessCheck) {
  return [
    {
        path: '/landing',
        name: 'landing',
        component: MitLandingPage
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: MitDashboardPage,
        meta: { allowedRole: MitUserModel.ROLES.USER },
        props: true,
        beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
        }
    },
    {
        path: '/settings',
        name: 'settings',
        component: MitSettingsPage,
        meta: { allowedRole: MitUserModel.ROLES.USER },
        props: true,
        beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
        }
    },
    {
        path: '/reserve',
        name: 'reserve',
        component: MitReservePage,
        meta: { allowedRole: MitUserModel.ROLES.USER },
        props: true,
        beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
        }
    },
    {
        path: '/reservations/my',
        name: 'reservations-my',
        component: MitMyReservationsPage,
        meta: { allowedRole: MitUserModel.ROLES.USER },
        props: true,
        beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
        }
    },
    {
      path: '/reservations/my/:id',
      name: 'reservations-my-id',
      component: MitMyReservationsPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/reservations/stats',
      name: 'reservations-stats',
      component: MitManagerDashboardPage,
      meta: { allowedRole: MitUserModel.ROLES.MANAGER },
      props: true,
      beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
      }
    },
    {
        path: '/reservations/audit',
        name: 'reservations-audit',
        component: MitManageAuditPage,
        meta: { allowedRole: MitUserModel.ROLES.MANAGER },
        props: true,
        beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
        }
    },
    {
        path: '/reservations/manage',
        name: 'reservations-manage',
        component: MitManageReservationsPage,
        meta: { allowedRole: MitUserModel.ROLES.MANAGER },
        props: true,
        beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
        }
    },
    {
      path: '/reservations/manage/:id',
      name: 'reservations-manage-id',
      component: MitManageReservationsPage,
      meta: { allowedRole: MitUserModel.ROLES.MANAGER },
      props: true,
      beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
      }
  },
    {
      path: '/reservations/setup',
      name: 'reservations-setup',
      component: MitManageReservationsSetupPage,
      meta: { allowedRole: MitUserModel.ROLES.MANAGER },
      props: true,
      beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
      }
  },
    {
        path: '/admin',
        name: 'admin',
        component: MitAdminPage,
        meta: { allowedRole: MitUserModel.ROLES.ADMIN },
        props: true,
        beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
        }
      },
      {
        path: '/admin/spaces',
        name: 'admin-spaces',
        component: MitAdminReservableSpacesPage,
        meta: { allowedRole: MitUserModel.ROLES.ADMIN },
        props: true,
        beforeEnter(to, from, next) {
            routerGuardAccessCheck(to, from, next);
        }
      },
      {
        path: '/admin/import',
        name: 'admin-import',
        component: MitAdminImportReservationsPage,
        meta: { allowedRole: MitUserModel.ROLES.ADMIN },
        props: true,
        beforeEnter(to, from, next) {
            routerGuardAccessCheck(to, from, next);
        }
      }
  ];
}
